module.exports = __webpack_public_path__ + "img/feature-04.667c3f3a.png";